import { combineReducers } from 'redux';
import { FETCH_PAGES_SUCCESS } from 'catalog/actions/pages';

const settings = (state = [], action) => {
  switch (action.type) {
    case FETCH_PAGES_SUCCESS:
      return action.settings;
    default:
      return state;
  }
};

const roles = (state = [], action) => {
  switch (action.type) {
    case FETCH_PAGES_SUCCESS:
      return action.roles;
    default:
      return state;
  }
};

const templates = (state = [], action) => {
  switch (action.type) {
    case FETCH_PAGES_SUCCESS:
      return action.templates;
    default:
      return state;
  }
};

export default combineReducers({
  settings,
  roles,
  templates,
});

export const getSettings = state => state.catalog.settings;
export const getRoles = state => state.catalog.roles;

export const getTemplates = state => state.catalog.templates;
export const getUnlockedTemplates = state =>
  getTemplates(state).filter(t => !t.isLocked);



// WEBPACK FOOTER //
// ./src/modules/catalog/reducers/catalog.js